




























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  DoceboCourseSessionsResponse,
  DoceboJoinWebinarSessionResponse,
  DoceboJoinSessionEventResponse,
} from '@/lib/DoceboAPI';
import SessionLocation from '@/components/atoms/SessionLocation.vue';
import SessionDateTime from '@/components/atoms/SessionDateTime.vue';
import NewcrossButton from '@/components/atoms/NewcrossButton.vue';
import HTMLContainer from '@/components/atoms/HTMLContainer.vue';
import HealthForceGoApp from '@/lib/HealthForceGoApp';

@Component({
  components: {
    SessionLocation,
    SessionDateTime,
    NewcrossButton,
    HTMLContainer,
  },
})
export default class CourseSessions extends Vue {
  @Prop() courseType!: 'classroom' | 'webinar';

  @Prop() courseId!: string;

  @Prop() courseSessions!: DoceboCourseSessionsResponse;

  private get learningPlanId(): string {
    return this.$route.params.learningPlanId;
  }

  private get catalogueId(): number {
    return Number(this.$route.params.catalogueId);
  }

  // eslint-disable-next-line class-methods-use-this
  private shouldShowJoinWebinarButton(
    date: string, // yyyy-MM-dd format
    startHour: string, // HH:mm format
    joinInAdvanceUser: string, // mm format
    duration: number // mm format
  ): boolean {
    const minsToMsMultiplier = 60000;
    const nowMs = Date.now();
    const startMs = Date.parse(`${date}T${startHour}`);
    const advanceMs = Number(joinInAdvanceUser) * minsToMsMultiplier;
    const durationMs = duration * minsToMsMultiplier;
    const earliestMs = startMs - advanceMs;
    const latestMs = startMs + durationMs;
    return nowMs > earliestMs && nowMs < latestMs;
  }

  // eslint-disable-next-line class-methods-use-this
  private shouldShowJoinSessionEventButton(
    date: string, // yyyy-MM-dd format
    timeBegin: string, // HH:mm:ss format
    joinInAdvanceUser: string, // mm format
    timeEnd: string // HH:mm:ss format
  ): boolean {
    const minsToMsMultiplier = 60000;
    const nowMs = Date.now();
    const startMs = Date.parse(`${date}T${timeBegin}`);
    const endMs = Date.parse(`${date}T${timeEnd}`);
    const advanceMs = Number(joinInAdvanceUser) * minsToMsMultiplier;
    const earliestMs = startMs - advanceMs;
    const latestMs = endMs;
    return nowMs > earliestMs && nowMs < latestMs;
  }

  private enrolOnSession(sessionId: number) {
    this.$store.dispatch('SET_LOADING_OVERLAY', 'Enrolling');
    this.$store
      .dispatch(
        'enrolments/ENROL_COURSE_SESSION',
        {
          courseId: this.courseId,
          sessionId,
        },
        {
          root: true,
        }
      )
      .then(null, (error) => {
        // Show error message returned from Docebo (Maximum enrollment quota exceeded?)
        const dialog = this.$dialog.show({
          title: error.message[0],
          buttons: [
            {
              label: 'Ok',
              handler: () => dialog.dismiss(),
            },
          ],
        });
      })
      .finally(() => this.$store.dispatch('SET_LOADING_OVERLAY', false));
  }

  private joinWebinar(courseId: string, sessionId: string, date: string) {
    this.$store.dispatch('SET_LOADING_OVERLAY', 'Joining');
    // Get URL for webinar and mark webinar as attended on Docebo
    this.$store
      .dispatch(
        'sessions/JOIN_WEBINAR',
        {
          courseId,
          sessionId,
          date,
        },
        {
          root: true,
        }
      )
      .then(
        (response: DoceboJoinWebinarSessionResponse) => {
          const dialog = this.$dialog.show({
            title:
              'This will open an external link outside of HealthForceGo, do you wish to continue?',
            buttons: [
              {
                label: 'Cancel',
                handler: () => dialog.dismiss(),
              },
              {
                label: 'Ok',
                handler: () => {
                  dialog.dismiss();
                  HealthForceGoApp.openExternalURL(response.data.join_url);
                },
              },
            ],
          });
        },
        (error) => {
          // Show error message returned from Docebo (Joining too early?)
          const dialog = this.$dialog.show({
            title: error.message[0],
            buttons: [
              {
                label: 'Ok',
                handler: () => dialog.dismiss(),
              },
            ],
          });
        }
      )
      .finally(() => this.$store.dispatch('SET_LOADING_OVERLAY', false));
  }

  private joinSessionEvent(eventId: string) {
    this.$store.dispatch('SET_LOADING_OVERLAY', 'Joining');
    // Get URL for webinar and mark webinar as attended on Docebo
    this.$store
      .dispatch('sessions/JOIN_SESSION_EVENT', eventId, {
        root: true,
      })
      .then(
        (response: DoceboJoinSessionEventResponse) => {
          const dialog = this.$dialog.show({
            title:
              'This will open an external link outside of HealthForceGo, do you wish to continue?',
            buttons: [
              {
                label: 'Cancel',
                handler: () => dialog.dismiss(),
              },
              {
                label: 'Ok',
                handler: () => {
                  dialog.dismiss();
                  HealthForceGoApp.openExternalURL(response.data.join_url);
                },
              },
            ],
          });
        },
        (error) => {
          // Show error message returned from Docebo (Joining too early?)
          const dialog = this.$dialog.show({
            title: error.message[0],
            buttons: [
              {
                label: 'Ok',
                handler: () => dialog.dismiss(),
              },
            ],
          });
        }
      )
      .finally(() => this.$store.dispatch('SET_LOADING_OVERLAY', false));
  }

  private reloadData() {
    this.$store.dispatch('SET_LOADING_OVERLAY', 'Loading');
    Promise.all([
      // Update catalogue
      this.$store.dispatch(
        'enrolments/GET_ENROLMENT_STATUS_FOR_CATALOGUE',
        Number(this.catalogueId),
        {
          root: true,
        }
      ),
      // If inside a learning plan, update the learning plan detail
      ...(this.learningPlanId
        ? [
            this.$store.dispatch(
              'learningPlan/GET_LEARNING_PLAN_DETAIL',
              this.learningPlanId,
              {
                root: true,
              }
            ),
          ]
        : []),
      // Update skills
      this.$store.dispatch('skills/GET_SKILLS_DATA'),
    ]).finally(() => {
      this.$store.dispatch('SET_LOADING_OVERLAY', false);
    });
  }
}
